export const navigationLinks = [
    {
        "icon": "mdi-home",
        "title": "主页",
        "url": "https://www.gaein.cn/"
    },
    {
        "icon": "mdi-book",
        "title": "博客",
        "url": "https://blog.gaein.cn"
    },
    {
        "icon": "mdi-link",
        "title": "友链",
        "url": "https://www.gaein.cn/friends/",
        "route_name": "friends"
    },
    {
        "icon": "mdi-information",
        "title": "关于",
        "url": "https://www.gaein.cn/about/",
        "route_name": "about"
    },
    {
        "icon": "mdi-github",
        "title": "GH",
        "url": "https://github.com/nidbCN"
    }
];

export const homeContent = [
    {
        "title": "GAEIN.CN",
        "content_list": [
            "Gaein nidb 的个人网站，搭建于2017年，记录和分享有趣的事情以及编程技术。",
            "主要活跃的是在博客，有时会发一些遇到的问题和解决方法，也经常发自己写的屑笔记。"
        ]
    },
    {
        "title": "Gaein nidb",
        "content_list": [
            "中北大学大一学牲，计算机专业，爱整烂活（x。",
            "从小学家里买了第一台电脑开始就对这东西充满好奇，初中时候粗略入门了C#编程语言，以及鼓捣各种东西，初三时候注册了这个域名，当时网站托管在虚拟主机上。",
            "热爱计算机专业，喜欢了解各种技术。正在努力的学习各种知识，并且规范自己的编程习惯。",
            "精神.NET人，最喜欢的语言是C#，当然，最近也可能去学一些别的好玩的。",
            "在玩的游戏只有 Minecraft 和 WorldOfWarships(Asia) ，WOWS摸鱼玩家，瞎开乱打涨血压。"
        ]
    }
];

export const aboutContent = [
    {
        "title": "关于我",
        "content_list": [
            "中北大学大一学牲，计算机专业，爱整烂活（x。",
            "爱好方面：计算机、摄影、航模（退坑），轻度打游戏（MC、ATRI和WOWS），亚托莉厨，因为推的太多了所以经常在群里模仿亚托莉（迫真自然语言处理）",
            "专业方面：计算机绝对不能局限于课本上的知识。打算并且正在学习Web后端和微服务等，前端组件库用户，纯摸鱼。喜欢摸鱼，不是很喜欢算法（主要是太头疼了）。精神.NET人，最喜欢的语言是C#，C、Python等也能凑合摸摸鱼，比较偏向于强类型的语言，最近在巩固C#基础，有学习其它语言的打算。",
            "生活方面：不是一个拘小节的人，平时比较大大咧咧，标准北方人性格。喜欢吃，但是不吃蘑菇（吃了的反应详见伊雷娜），好吃就是高兴嘛（美味しいは嬉しい）！",
            "交友方面：跟谁都大概能聊得来，讨厌过于做作的人，以及某些自以为很有权势的人。"
        ],
        "timeline": [
            {
                "icon": "mdi-flag",
                "color": "red",
                "title": "2012 - 开始",
                "content": "入坑 Minecraft，然后知道了Java这个玩意，逐渐了解到了冰山一角。看着当时小学书的VB开始了编程（瞎玩）之旅，也写了一些毫无卵用的沙雕脚本，但是给了我很大的成就感。"
            },
            {
                "icon": "mdi-code-tags",
                "color": "blue",
                "title": "2016 - .NET与C#",
                "content": "装了Visual Studio 2015之后发现里面的VB明明和VB6是两码事嘛！然后就这样阴差阳错的接触到了.NET。同样是因为 Minecraft ，由一个启动器（HeyoX）的开发者我了解到了C#，转而去学习C#，也第一次接触到了代码托管（用的是Coding）、前端、还有nodeBB（不过当时并没有意识到）。"
            },
            {
                "icon": "mdi-chip",
                "color": "grey",
                "title": "2017 - 硬件",
                "content": "已经完全想不起来怎么了解上硬件的了，大概原因是我妈说中考完要给我买电脑。于是入了图吧，当年那个i3默秒全的时代，拥有一块i5 2500k是我最大的梦想。放假回家有事没事就把自己电脑拆开再装回去，也捡了一些垃圾（包括一块鱼竿固态，几条DDR3条子还有一张GT240，当时可都是我的宝贝）。"
            },
            {
                "icon": "mdi-pen",
                "color": "green",
                "title": "2018 - C++&NOIP",
                "content": "别看了别看了，想打NOIP被班主任劝退了。当时还买了一本《C++ Primer Plus》，物理课（划）认真看到了指针左右，虽然没学到啥，但是好歹算是基础又过了一下（C、C++、C#、Java都是C-Style的语言，还挺有用的）。"
            },
            {
                "icon": "mdi-ubuntu",
                "color": "#E95420",
                "title": "2019 - Linux",
                "content": "2018年末因为想搭建 nodeBB 玩而接触了云服务器，2019年彻底将网站迁移到了云服务器上。在配置环境的过程中，也学会了很多基础使用方法。开始逐渐转Web。"
            },
            {
                "icon": "mdi-book",
                "color": "green",
                "title": "2020 - 学习",
                "content": "当然，高三这一年大部分时间还是放在备考上了。疫情期间和 Elissa 大佬一起写了一些网站，学了 LayUI 和一点 PHP，也了解了一些前后端交互的过程和方法。暑假经过激烈的思想斗争最终决定专业优先，选择了计算机。在家跟着翁恺的网课学了C语言，对规范代码有了一定的概念。上学后看了没两天Java就回C#了，也瞎写了一些ASP.NET Core（但是纯瞎写）。"
            },
            {
                "icon": "mdi-road-variant",
                "color": "purple",
                "title": "2021 - 新起点",
                "content": "寒假跟着杨旭老师在哔哩哔哩上的视频了解了很多ASP.NET Core的知识，也了解了一些基础的后端知识和HTTP知识。未来计划深入.NET，继续学C#（目前在按着《C#高级编程》巩固相关知识），未来也想要去学习微服务，或者人工智能相关的一些东西。"
            }
        ]
    },
    {
        "title": "关于网站",
        "content_list": [
            "Gaein nidb 的个人网站，搭建于2017年，记录和分享有趣的事情以及编程技术。",
            "目前部署在北京阿里云轻量应用服务器上，博客和一些静态网站有阿里云CDN，使用阿里云DNS。",
            "前端页面为 Vue.Js + Vuetify，部分后端为 Asp.NET Core。",
            "很高兴我的网站已经4年多了，而我还没有放弃它（笑），希望以后能够学到更多的Web知识吧！"
        ],
        "timeline": [
            {
                "icon": "mdi-flag",
                "color": "red",
                "title": "2017.03 - 开始",
                "content": "在主机屋上白嫖的空间，啥也不会的我下载、修改的网上的模板，然后FTP上传到网站空间。就这样对Web的兴趣开始了。"
            },
            {
                "icon": "mdi-tools",
                "color": "indigo",
                "title": "2017.04 - 建站",
                "content": "下血本买了空间，搭建了基于PHP的ZBlog，当时的域名还是 nidb.pw 。后来注册了 Gaein.cn 开始着手准备备案。4月30号发了第一篇博客。随着时间的流逝，我的服务器上已经不再部署PHP，因此静静躺在数据库里的旧博客也只有我自己能偶尔翻翻看看。"
            },
            {
                "icon": "mdi-shield-check",
                "color": "green",
                "title": "2017.05 - 备案",
                "content": "当时还没有十六周岁的我神奇的备案通过了（后来证实很多IDC那边不够16都不能审核过）。因为在初三，也没有手机和电脑，只能放假回家来准备材料，当时还是要邮寄幕布和材料，着实费了很大功夫。但是河北管局仍然在第20个工作日的时候批准了我的备案，终于可以把网站迁到大陆了。"
            },
            {
                "icon": "mdi-server",
                "color": "blue",
                "title": "2018.10 - 服务器",
                "content": "因为玩 nodeBB 接触到了云服务器（其实以前也知道就是不会用而已）。然后学习了很多 Linux 的基础指令，发现无论是自由度还是可玩性都比空间有很大提升，于是租用了云服务器，将博客等迁移到云服务器上。将博客转移到了HEXO，顺带还配置了子域名和HTTPS。"
            },
            {
                "icon": "mdi-transfer-right",
                "color": "orange",
                "title": "2019.04 - 阿里云",
                "content": "发现了阿里云的云翼计划，不用学生证认证（因为我们高中的学生证是没法认证的，很多优惠都是大学生的）。于是决定从主机屋转到阿里云，着手准备数据迁移、备案迁移，然后更“优雅”的配好了环境（当然那环境现在看来还是一坨shit）。"
            },
            {
                "icon": "mdi-home",
                "color": "grey",
                "title": "2020.04 - 首页",
                "content": "尝试着自己使用 LayUI 这个框架来制作自己的首页（也就是上一版网站首页）。疫情期间还接触并稍微学习了一些 PHP ，糊了一个考勤签到系统（200%纯屎山）。得益于 Elissa 大佬带我写东西，稍微学习了一些前端、后端知识以及前后端如何交互。"
            },
            {
                "icon": "mdi-road-variant",
                "color": "purple",
                "title": "2021.04 - 新开始",
                "content": "大学期间相较于以前学习到了很多（当然，还远远不足）。由于阿里云政策变更，重新购买了一台服务器，并完全重新配置。完善各种配置，将后端运行到 Docker 里。以及...使用 Vue + Vuetify 重写自己的页面！但是在对于这行业不断的了解中，我似乎更倾向去做后端。"
            }
        ]
    }
];

export const aboutInfo = {
    "title": "信息",
    "content": [
        {
            "title": "公钥信息",
            "content": [
                {
                    "title": "win-book",
                    "content": "ssh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAAIGaBrk5+qmAlUVVAd5I98mG93lWrqEZ8hLaGihl1acfF mail@gaein.cn/win-book"
                },
                {
                    "title": "win-desktop",
                    "content": "ssh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAAIG7ZbC3Qw6NYJK/9KUMU0e+iw+A5H3zoUPbcNauEW1Q6 mail@gaein.cn/win-desktop"
                },
                {
                    "title": "win-itx",
                    "content": "ssh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAAIGsqlpgSugFoEBScOmi/D/3pwvkIt25cLtNEr2PL74T+ mail@gaein.cn"
                },
                {
                    "title": "ubuntu-cloud",
                    "content": "ssh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAAIC7tbVFCd9XBhG6CB+U6vHtMM8DgW9Q/0xsaXHrN8hZL mail@gaein.cn/ubuntu-cloud"
                }
            ]
        }
    ]
};

export const friendLinks = [
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/kenvix-com.webp",
        "title": "Kenvix's Blog",
        "description": "一条业余写代码的咸鱼的博客",
        "url": "https://kenvix.com/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/dreace-top.webp",
        "title": "DreaceのBlog",
        "description": "好耶，是巨佬倪神！",
        "url": "https://blog.dreace.top/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/www-yunyoujun-cn.webp",
        "title": "云游君的小站",
        "description": "希望能成为一个有趣的人",
        "url": "https://www.yunyoujun.cn/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/rainchan-win.webp",
        "title": "RainChan的小博客",
        "description": "雨酱的小博客",
        "url": "https://rainchan.win/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/umb-ink.webp",
        "title": "UmbのBlog",
        "description": "好耶，是伞菌姐姐的博客！",
        "url": "https://umb.ink/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/blog-fivezha-cn.webp",
        "title": "异国迷宫的十字路口",
        "description": "一位弱鸡带学生的个人博客",
        "url": "https://blog.fivezha.cn/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/www-freejishu-com.webp",
        "title": "freejishu",
        "description": "freejishu的美丽世界 - 一个全新的境界",
        "url": "https://www.freejishu.com/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/aimerneige-com.webp",
        "title": "AimerNeige's Blog",
        "description": "Tech Otakus Save The World",
        "url": "https://aimerneige.com/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/ishero-net.webp",
        "title": "鸢尾花开",
        "description": "不积跬步无以至千里，持续更新！",
        "url": "http://ishero.net/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/www-makedream-site.webp",
        "title": "Makedream",
        "description": "我拥有的都是侥幸 ——anpu",
        "url": "https://aimerneige.com/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/alpaca-kim.webp",
        "title": "Alpaca的博客",
        "description": "一只BUPT菜鸡的心路历程",
        "url": "https://alpaca.kim/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/github-com-xh321.webp",
        "title": "xh321",
        "description": "好耶，是某个非要加友链的屑阿何！",
        "url": "http://blog.xiaohe321.net/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/www-yukari-one.webp",
        "title": "Yukari316's blog",
        "description": "饼干的歇脚小地",
        "url": "https://www.yukari.one/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/bleatingsheep-org.webp",
        "title": "bleatingsheep 的博客",
        "description": "好耶，是ymy姐姐哦！",
        "url": "https://bleatingsheep.org/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/xuanli-cc.webp",
        "title": "玹狸的摸鱼基地",
        "description": "",
        "url": "https://blog.xuanli.cc/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/www-wdvxdr-com.webp",
        "title": "wdvxdr's blog",
        "description": "我的全新 Hugo Blog !",
        "url": "https://www.wdvxdr.com/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/skipm4-com.webp",
        "title": "SkipM4 的日记本",
        "description": "虽然可能连周记都忘了写的日记本",
        "url": "https://skipm4.com/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/blog-truimo-com.webp",
        "title": "浅小沫的笔记",
        "description": "若没人陪你颠沛流离，便以梦为马随处而栖",
        "url": "https://blog.truimo.com/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/println-org.webp",
        "title": "Alex",
        "description": "永远相信技术的力量",
        "url": "https://println.org/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/peanutmelonseedbigalmond-github-io.webp",
        "title": "子虚乌有的剪切板",
        "description": "一个单纯的剪切板",
        "url": "http://peanutmelonseedbigalmond.github.io/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/ardor-one.webp",
        "title": "回响小站",
        "description": "Simply & Naive",
        "url": "https://ardor.one/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/www-roboticwings-me.webp",
        "title": "ROBOTIC WINGS",
        "description": "ENTP，混吃等死",
        "url": "https://www.roboticwings.me/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/www-shan-net-com.webp",
        "title": "小林的小筏",
        "description": "小林的小筏,随便写写",
        "url": "https://www.shan-net.com/"
    },
    {
        "avatar": "https://img.cdn.gaein.cn/website_used/frineds-avatars/yjblogs-cn.webp",
        "title": "勇杰的博客",
        "description": "希望能成为一个有趣的人，创造出可以成为他人回忆的事物。",
        "url": "https://yjblogs.cn/"
    }
];

export const errorLinks = [
    {
        "icon": "mdi-home",
        "title": "主页",
        "url": "https://www.gaein.cn/"
    },
    {
        "icon": "mdi-book",
        "title": "博客",
        "url": "https://blog.gaein.cn"
    },
    {
        "icon": "mdi-github",
        "title": "Github",
        "url": "https://github.com/nidbCN"
    }
];

export const errorMessages = {
    "401": {
        "msg": "喂喂喂...你谁啊你！（盯——",
        "details": "这里可是要登录才能看的哦（叉腰，我可没有看见谁授权给你呀！"
    },
    "403": {
        "msg": "人家才不要给你看呢，哼！",
        "details": "喂！URL输错了叭，不过...如果你是故意的那么请你爬！哼唧！！！"
    },
    "404": {
        "msg": "诶诶诶？找不到了呢（低头",
        "details": "喂！URL输错了叭，不过也有可能是页面已经被移走/删掉啦，这个人家也没办法哦~"
    },
    "500": {
        "msg": "哎呀！坏掉了，真是的...",
        "details": "后端娘生病了吗，看起来不太好的亚子诶，咱也不知道怎么办诶，等会再来看看吧！"
    },
    "502": {
        "msg": "诶？后端姐姐不理咱了~",
        "details": "诶呀，收不到上游的响应诶，真是的...咱也不知道怎么办诶，等会再来看看吧！"
    }
};

export const defaultErrorMessage = {
    msg: '未知的 HTTP 状态码',
    details: '没有找到这个状态码的详细说明。',
};
